import { EnumTipoDoctor } from "../settings/enumConfig";

export const getModelColaboradorCallCenter = () => ({
    iIdColaborador: 0,
    iIdTipoDoctor: EnumTipoDoctor.CallCenter,
    bInterno: true,
});

export const getModelColaboradorEspecialista = () => ({
    iIdColaborador: 0,
    iIdTipoDoctor: EnumTipoDoctor.Especialista,
});

export const getFormColaborador = () => ({
    txtNombreDirectorio: {
        label: "Nombre corto para mostrar en directorio:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del doctor es requerido",
        placeholder: "Ej. Dr. Ignacio Ochoa",
    },
    txtCedulaDirectorio: {
        label: "Cédula profesional:",
        required: true,
        value: "",
        error: false,
        message: "La cédula profesional es requerida y debe tener 8 caractéres",
    },
    txtRFCDirectorio: {
        label: "RFC:",
        required: true,
        value: "",
        error: false,
        message: "El RFC del doctor es requerido y debe tener 13 caractéres",
    },
    txtTelefonoDirectorio: {
        label: "Teléfono de contacto:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un teléfono de contacto válido",
    },
    txtWhatsAppDirectorio: {
        label: "WhatsApp:",
        required: false,
        value: "",
        error: false,
        message: "Ingrese un teléfono de contacto válido",
    },
    txtEmailDirectorio: {
        label: "Correo electrónico de contacto:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un email de contacto válido",
    },
    rdEspecialidad: {
        label: "Especialidad:",
        value: "",
        message: "Tipo de Especialidad:",
    },
    slcEspecialidad: {
        label: "Especialidad:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione una especialidad",
    },
    txtNumeroSala: {
        label: "Número de sala:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un número de sala válido",
    },
    txtNombreConsultorio: {
        label: "Nombre del consultorio:",
        required: false,
        value: "",
        error: false,
        message: "El nombre de consultorio es requerido",
    },
    txtDireccionConsultorio: {
        label: "Dirección del consultorio:",
        required: false,
        value: "",
        error: false,
        message: "La dirección del consultorio es requerida",
    },
    txtUrlDirectorio: {
        label: "Sitio web del doctor:",
        required: false,
        value: "",
        error: false,
        message: "Ingrese una URL válida",
    },
    txtMapsDirectorio: {
        label: "Ubicación en Google Maps:",
        required: false,
        value: "",
        error: false,
        message: "Ingrese una URL válida de Google Maps",
        placeholder: "Ejemplo: https://goo.gl/maps/oD3FDomx7WVGRHN39",
    },
    txtNombreDoctor: {
        label: "Nombres:",
        required: true,
        value: "",
        error: false,
        message: "El nombre del doctor es requerido",
    },
    txtApellidoPaternoDoctor: {
        label: "Apellido paterno:",
        required: true,
        value: "",
        error: false,
        message: "El apellido paterno es requerido",
    },
    txtApellidoMaternoDoctor: {
        label: "Apellido materno:",
        required: false,
        value: "",
        error: false,
        message: "El apellido materno es requerido",
    },
    dtpFechaNacimientoDoctor: {
        label: "Fecha de nacimiento:",
        required: true,
        value: null,
        error: false,
        message: "Seleccione la fecha de nacimiento (El colaborador deber ser mayor de 18 años)",
    },
    txtTelefonoDoctor: {
        label: "Teléfono personal:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un teléfono de contacto válido",
    },
    txtEmailDoctor: {
        label: "Correo electrónico personal:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un email de contacto válido",
    },
    txtDomicilioDoctor: {
        label: "Domicilio particular:",
        required: false,
        value: "",
        error: false,
        message: "El domicilio del doctor es requerido",
    },
    txtUsuarioTitular: {
        label: "Usuario:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el username de usuario titular",
    },
    txtPasswordTitular: {
        label: "Contraseña:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese la contraseña de usuario titular",
    },
    txtUsuarioAdmin: {
        label: "Usuario:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese el username de usuario administrativo",
    },
    txtPasswordAdmin: {
        label: "Contraseña:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese la contraseña de usuario administrativo",
    },
    chkDoctorAdm: {
        label: "Director:",
        required: true,
        value: false,
        error: false,
        message: "Dar permisos administrativos como Director",
    },
    chkAccesoDoctor: {
        label: "Acceso:",
        required: true,
        value: true,
        error: false,
        message: "Dar permisos de acceso al Portal Meditoc CallCenter",
    },
});

export const getColaboradorColumns = () => [
    { title: "ID", field: "iIdColaborador" },
    { title: "Tipo de doctor", field: "sTipoDoctor" },
    { title: "Especialidad", field: "sEspecialidad" },
    { title: "Nombre", field: "sNombreDirectorio" },
    { title: "Usuario", field: "sUsuarioTitular" },
    { title: "Sala", field: "iNumSala" },
    { title: "Acceso", field: "sAcceso" },
];
